import React, { Component } from 'react';
import { Row, Col } from 'react-flexbox-grid';
import styled from 'styled-components';
import ReactSVG from 'react-svg';
import MediaQuery from 'react-responsive';

import { PageGrid } from '../shared/CommonStyledComponents';
import NextPageLink from '../shared/NextPageLink';

import leafyCodeTeam from '../assets/images/leafycode-team.svg';
import leafyCodeMobileTeam from '../assets/images/mobile-team-animated.svg';
import ourServicesSideLink from '../assets/images/sideLinks/our_services_side_link.svg';


const GreetingContainer = styled(Col)`
  display: flex;
  align-items: center;
`;

const GreetingContainerInner = styled.div`
  @media (max-width: 64em) {
    width: 100%;
  }
`;

const Greeting = styled.span`
  font-family: 'Raleway', sans-serif;
  font-size: 7.5vw;
  font-weight: 900;
  color: #ffb317;
  margin-left: -6px;

  @media (max-width: 64em) {
    text-align: center;
    margin: auto;
    display: block;
    font-size: 21vw;
  }
`;

const ShortIntro = styled.h2`
  font-weight: 200;
  font-size: 1.76vw;
  line-height: 0.92;
  margin-top: -3px;

  @media (max-width: 64em) {
    text-align: center;
    font-size: 5.76vw;
    line-height: 1.1;
    margin-top: 0px;
  }
`;

const MoreButton = styled.button`
  font-size: 1.08vw;
  font-weight: 600;
  margin-top: -11px;
  cursor: pointer;
  background: none;
  border: none;
  outline: none;
  padding: 0;

  @media (max-width: 64em) {
    font-size: 3.8vw;
    display: block;
    text-align: center;
    margin-bottom: 31px;
    margin-left: auto;
    margin-right: auto;
  }
`;

const AboutTeamContainer = styled(Col)`
  opacity: 1
  -webkit-transition: opacity 0.4s;
  transition: opacity 0.4s;
`;

const AboutUs = styled.div`
  font-size: 1.2vw;
  line-height: 1.7vw;
  column-count: 2;

  p{
    margin-top: 0;
  }

  @media (max-width: 64em) {
    p{
      font-size: 3.2vw;
      line-height: 4.7vw;
    }
  }
`;

const CloseAboutButton = styled.button`
  border: 0;
  margin-top: 1vw;
  background-color: #ffffff;
  padding: 0.5vw 2vw;
  display: inline-block;
  text-align: center;
  font-size: 1.3vw;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  position: relative;
  overflow: hidden;
  -webkit-transition: color 0.4s;
  transition: color 0.4s;
  color: #262636;
  text-decoration: none;
  outline: none;

  &:after{
    background-color: #262636;
    content: '.';
    transform: skewX(15deg);
    position: absolute;
    top: 0;
    left: -10%;
    height: 100%;
    width: 0%;
    color: #262636;
    z-index: 1;
    -webkit-transition: width 0.4s;
    transition: width 0.4s;
  }

  .link-text{
    z-index: 4;
    position: relative;
  }

  &:hover{
    color: #fff;

    &:after{
      width: 120%;
    }
  }

  @media (max-width: 64em) {
    padding: 1.7vw 6vw;
    font-size: 4.3vw;
    margin-top: 5vw;
    margin-bottom: 12vw;
    display: block;
    width: 29vw;
  }
`;


const animateTeam = () => {
  window.PagesSweeper.update();

  const leafyTeam = document.getElementById('leafy-team');

  if (leafyTeam) {
    // Start the line drawing
    leafyTeam.classList.add('start');
    setTimeout(() => {
        // Signal the end of the drawing to start the fill color animation
      leafyTeam.classList.add('finished');
    }, 2500);
  }

  // Animate the clock hands
  const teamClockHourHand = document.getElementById('team-clock-hour');
  const teamClockMinuteHand = document.getElementById('team-clock-minute');
  const teamClockSecondHand = document.getElementById('team-clock-second');

  if (teamClockSecondHand && teamClockHourHand && teamClockMinuteHand) {
    const runTheClock = () => {
      const date = new Date();
      const hour = date.getHours();
      const minute = date.getMinutes();
      const second = date.getSeconds();

      const hoursRotationDeg = ((hour * 360) / 12) + ((minute * (360 / 60)) / 12);
      const minutesRotationDeg = ((minute * 360) / 60) + ((second * (360 / 60)) / 60);
      const secondsRotationDeg = (second * 360) / 60;

      teamClockHourHand.style.transform =
        `rotate(${hoursRotationDeg}deg)`;
      teamClockMinuteHand.style.transform =
        `rotate(${minutesRotationDeg}deg)`;
      teamClockSecondHand.style.transform =
        `rotate(${secondsRotationDeg}deg)`;
    };

    setInterval(() => {
      runTheClock();
    }, 1000);
  }
};

class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showAbout: false
    };

    this.aboutUsToggle = this.aboutUsToggle.bind(this);
  }

  aboutUsToggle() {
    const { showAbout } = this.state;

    const aboutTeamContainerElement = document.getElementById('about-team-container');

    aboutTeamContainerElement.classList.add('updating');

    setTimeout(() => {
      this.setState({
        showAbout: !showAbout
      });

      aboutTeamContainerElement.classList.remove('updating');
    }, 400);
  }

  render() {
    const { showAbout } = this.state;

    return (
      <PageGrid id="home">
        <Row>
          <GreetingContainer xs={12} md={4}>
            <GreetingContainerInner>
              <Greeting>Hello!</Greeting>
              <ShortIntro>
                We are a team of<br />
                software developers...
              </ShortIntro>
              <MoreButton onClick={this.aboutUsToggle}>
                Learn more
              </MoreButton>
            </GreetingContainerInner>
          </GreetingContainer>
          <AboutTeamContainer xs={12} md={6} id="about-team-container">
            {showAbout ?
              <AboutUs className="styled-links">
                <p>
                  We are a unique team of software engineers trying to do something great.
                   We always try to accept new challenges and innovate. You can clearly see
                   that from our own website. It does not behave like a regular website.
                   It&apos;s different. We are different.
                </p>
                <p>
                  We try to do things the right way and give our clients what they deserve.
                  Better, maintainable, and unique solutions which we craft ourselves.
                </p>
                <p>
                  Our team enjoy the work. For us, coding is like writing a poem. We always
                  try to share what we learn here with other developers through meetups
                  and podcasts. Yes, we also do
                  <a href="https://leafykatha.live/" target="_blank" rel="noopener noreferrer">
                  &nbsp;podcasts</a> to help our community!
                </p>
                <p>
                  We are not just another software company. We have so much more to offer
                  you. If you need something created in the right way, something unique,
                  something innovative and something remarkable... let us help you!
                </p>
                <CloseAboutButton onClick={this.aboutUsToggle}>
                  <span className="link-text">Close</span>
                </CloseAboutButton>
              </AboutUs> :
              <div>
                <MediaQuery minWidth={992}>
                  <ReactSVG
                    path={leafyCodeTeam}
                    callback={() => {
                      animateTeam({ mobile: false });
                    }}
                  />
                </MediaQuery>

                <MediaQuery maxWidth={991}>
                  <ReactSVG
                    path={leafyCodeMobileTeam}
                    callback={() => {
                      animateTeam();
                    }}
                  />
                </MediaQuery>
              </div>
            }
          </AboutTeamContainer>
        </Row>
        <NextPageLink
          color="80cbc3"
          image={ourServicesSideLink}
          text="OUR SERVICES"
        />
      </PageGrid>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js